<div class="grid-x grid-margin-x margin" [formGroup]="financialForm">
  <div class="cell small-12 xmedium-7"><h4 class="subsection" [innerHTML]="textkeyPrefix + '.auswahl' | translate"></h4></div>
  <div class="cell small-12 xmedium-5">&nbsp;</div>
  <div class="cell small-12 xmedium-7 small-order-2 xmedium-order-1">
    <div class="grid-x align-center">
      @if (anfrage?.measureResult?.costs?.financing?.foerderkredit) {
        <div class="cell small-6 medium-4">
          <button class="button tab-nav" [class.primary]="financing === 'foerderkredit'" [class.secondary]="financing !== 'foerderkredit'" (click)="onFinancingChange('foerderkredit')">
            {{ textkeyPrefix + '.foerderkredit' | translate }}
            <small>{{ (anfrage.measureResult.costs.financing.foerderkredit.kreditrate_jahr / 12) | number: '1.0-0' }} €</small>
          </button>
        </div>
      }
      @if (anfrage?.measureResult?.costs?.financing?.bankkredit) {
        <div class="cell small-6 medium-4">
          <button class="button tab-nav" [class.primary]="financing === 'bankkredit'" [class.secondary]="financing !== 'bankkredit'" (click)="onFinancingChange('bankkredit')">
            {{ textkeyPrefix + '.bankkredit' | translate }}
            <small>{{ (anfrage.measureResult.costs.financing.bankkredit.kreditrate_jahr / 12) | number: '1.0-0' }} €</small>
          </button>
        </div>
      }
    </div>

    @if (anfrage.measureResult?.costs) {
      <div class="finance-wrapper" [class.loading-overlay]="loading || financeSwitch" [class.loading-spinner-top]="financeSwitch">
        <div class="invest-row sum">
          <span [innerHTML]="textkeyPrefix + '.gesamt' | translate"></span>
          <span>{{ anfrage.measureResult.costs.overall.sum | number: '1.0-0' }} €</span>
        </div>
        @for (grant of anfrage.measureResult.costs.financing[financing].funding_grants.grants; track grant.name) {
          <div class="invest-row funding">
              <span>
                <span
                  class="label gray"
                  [innerHTML]="(textkeyPrefix + '.zuschuss.' + (grant.kreditgebunden? 'tilgung' : 'foerderung')) | translate"
                ></span>
                <br>
                {{ grant.name }}
              </span>
            <span>{{ grant.wert | number: '1.0-0' }} €</span>
          </div>
        }
        @if (anfrage.measureResult.costs.financing[financing].funding_grants.sum > 0) {
          <div class="invest-row subtotal">
            <span>
              {{ textkeyPrefix + '.zuschuss' | translate }}
              <app-sanierung-help-button [toggles]="toggle" toggleName="helpZuschuss"></app-sanierung-help-button>
            </span>
            <span>{{ anfrage.measureResult.costs.financing[financing].funding_grants.sum | number: '1.0-0' }} €</span>
          </div>
          <app-sanierung-help-callout
            [toggles]="toggle"
            toggleName="helpZuschuss"
            [textkey]="textkeyPrefix + '.zuschuss.hilfe.' + financing"
          ></app-sanierung-help-callout>
        }
        @if (anfrage.measureResult.costs.overall.sum - (anfrage.measureResult.costs.financing[financing].funding_grants.sum ?? 0) > 0) {
          <div class="invest-row">
            <span [innerHTML]="textkeyPrefix + '.eigenkapital' | translate"></span>
            <mat-slider
              class="round-knob push"
              [step]="sliderConfig.step"
              [min]="sliderConfig.min"
              [disableRipple]="true"
              [max]="sliderConfig.max"
              [discrete]="false"
              (input)="onSliderChange($event)"
            >
              <input
                matSliderThumb
                (dragEnd)="onMeasureSelectionChange(false)"
                formControlName="eigenkapital"
              >
            </mat-slider>
            <span class="min-width">
              {{ (anfrage.finanzierungInput?.eigenkapital?? 0) | number: '1.0-0' }} €
            </span>
          </div>
        }
        <div class="invest-row subtotal">
              <span>
                {{ (textkeyPrefix + '.rest.' + financing) | translate }}
                <app-sanierung-help-button [toggles]="toggle" toggleName="helpRest"></app-sanierung-help-button>
              </span>
          <span>{{ anfrage.measureResult.costs.financing[financing].rest | number: '1.0-0' }} €</span>
        </div>
        <app-sanierung-help-callout
          [toggles]="toggle"
          toggleName="helpRest"
          [textkey]="textkeyPrefix + '.rest.hilfe'"
        ></app-sanierung-help-callout>
        @for (loan of anfrage.measureResult.costs.financing[financing].promotional_loan.loans; track loan.name) {
          <div class="invest-row funding">
            <span>
              <span class="label gray" [innerHTML]="textkeyPrefix + '.foerderung.kredit' | translate"></span>
              <br>
              {{ loan.name }}
            </span>
            <span>{{ loan.kreditsumme | number: '1.0-0' }} €</span>
          </div>
        }
        @if (anfrage.measureResult.costs.financing[financing]?.bankkredit?.kreditsumme != 0) {
          @if (financing === 'foerderkredit') {
            <div class="invest-row" [class.no-margin]="financing === 'foerderkredit'">
              <span>
                {{ textkeyPrefix + '.bankkredit' | translate }}
                <app-sanierung-help-button [toggles]="toggle" toggleName="helpBankkredit"></app-sanierung-help-button>
              </span>
              <span>{{ anfrage.measureResult.costs.financing[financing].bankkredit.kreditsumme | number: '1.0-0' }} €</span>
            </div>
            <app-sanierung-help-callout
              [toggles]="toggle"
              toggleName="helpBankkredit"
              [textkey]="textkeyPrefix + '.bankkredit.hilfe'"
            ></app-sanierung-help-callout>
          }
          <div class="invest-row">
            <span>
              {{ textkeyPrefix + '.zinssatz' | translate }}
              <app-sanierung-help-button [toggles]="toggle" toggleName="helpZinssatz"></app-sanierung-help-button>
            </span>
            @if(interestRateDefault !== (financialForm?.controls?.zinssatz?.value * 1)) {
              <button class="button secondary push" (click)="onReset()">
                <i class="icon-return"></i>
                <span class="show-for-large">{{ textkeyPrefix + '.zinssatz.reset' | translate }}</span>
              </button>
            }
            <span>
              <div class="formfield">
                <div class="input-group type-number text-label">
                  <div class="input-group-button">
                    <button (click)="onDecrease()" type="button" [attr.aria-label]="'arialabel.minus' | translate"><i class="icon-minus-circle"></i></button>
                  </div>
                  <div class="input-group-label middle">
                    {{ financialForm?.controls?.zinssatz?.value | number: '1.1-1' }}%
                  </div>
                  <div class="input-group-button">
                    <button (click)="onIncrease()" type="button" [attr.aria-label]="'arialabel.plus' | translate"><i class="icon-plus-circle"></i></button>
                  </div>
                </div>
              </div>
            </span>
          </div>
          <app-sanierung-help-callout
            [toggles]="toggle"
            toggleName="helpZinssatz"
            [textkey]="textkeyPrefix + '.zinssatz.hilfe'"
          ></app-sanierung-help-callout>
        }
        <div class="invest-row hint" [innerHTML]="textkeyPrefix + '.hinweis.tabelle' | translate"></div>
        <div class="invest-row sum">
          <span>
            {{ textkeyPrefix + '.rate' | translate }}
            <app-sanierung-help-button [toggles]="toggle" toggleName="helpRate"></app-sanierung-help-button>
          </span>
          <span>{{ (anfrage.measureResult.costs.financing[financing].kreditrate_jahr / 12) | number: '1.0-0' }} €</span>
        </div>
        <app-sanierung-help-callout
          [toggles]="toggle"
          toggleName="helpRate"
          [textkey]="textkeyPrefix + '.rate.hilfe.' + financing"
        ></app-sanierung-help-callout>
      </div>
    }
  </div>
  <div class="cell small-12 xmedium-5 small-order-1 xmedium-order-2">
    <div class="side-help margin">
      <button
        class="help-toggle hide-for-xmedium"
        [class.active]="toggle.sideHelp"
        (click)="toggle.sideHelp = !toggle.sideHelp"
      >{{(toggle.sideHelp? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}}
        <i [class]="toggle.sideHelp? 'icon-x-circle' : 'icon-info'"></i>
      </button>
      <div [class.show]="toggle.sideHelp">
        <p [innerHTML]="(textkeyPrefix + '.hint.' + financing) | translate"></p>
        @if (financing === 'foerderkredit') {
          <div class="callout gray callout-icon">
            <i class="icon-info"></i>
            <p [innerHTML]="textkeyPrefix + '.datenbank' | translate"></p>
          </div>
        }
      </div>
    </div>


  </div>
</div>
